function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 505 505",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FD8469"
    },
    cx: 252.5,
    cy: 252.5,
    r: 252.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M401.9,407.6h-304c-1.7,0-3.1-1.4-3.1-3.1v-304c0-1.7,1.4-3.1,3.1-3.1h304c1.7,0,3.1,1.4,3.1,3.1v304 C405,406.2,403.6,407.6,401.9,407.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M205.2,209h-80.6c-0.6,0-1.1-0.5-1.1-1.1v-80.6c0-0.6,0.5-1.1,1.1-1.1h80.6c0.6,0,1.1,0.5,1.1,1.1 v80.6C206.4,208.5,205.8,209,205.2,209z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.3,
    y: 134.9,
    style: {
      fill: "#FFFFFF"
    },
    width: 65.4,
    height: 65.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 145.7,
    style: {
      fill: "#324A5E"
    },
    width: 43.8,
    height: 43.8
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M372.4,209h-80.6c-0.6,0-1.1-0.5-1.1-1.1v-80.6c0-0.6,0.5-1.1,1.1-1.1h80.6c0.6,0,1.1,0.5,1.1,1.1 v80.6C373.5,208.5,373,209,372.4,209z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 299.4,
    y: 134.9,
    style: {
      fill: "#FFFFFF"
    },
    width: 65.4,
    height: 65.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 310.2,
    y: 145.7,
    style: {
      fill: "#324A5E"
    },
    width: 43.8,
    height: 43.8
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M205.2,382.1h-80.6c-0.6,0-1.1-0.5-1.1-1.1v-80.6c0-0.6,0.5-1.1,1.1-1.1h80.6c0.6,0,1.1,0.5,1.1,1.1 V381C206.4,381.6,205.8,382.1,205.2,382.1z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 132.3,
    y: 308,
    style: {
      fill: "#FFFFFF"
    },
    width: 65.4,
    height: 65.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 318.8,
    style: {
      fill: "#324A5E"
    },
    width: 43.8,
    height: 43.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.1,
    y: 140.4,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 154.7,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.8,
    y: 168.9,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.1,
    y: 183.1,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.5,
    y: 222,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.5,
    y: 250.5,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.4,
    y: 264.7,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.2,
    y: 222,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.8,
    y: 236.3,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.2,
    y: 236.3,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.1,
    y: 222,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.9,
    y: 250.5,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.8,
    y: 236.3,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.8,
    y: 307.5,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.7,
    y: 279,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.7,
    y: 321.7,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.4,
    y: 279,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.4,
    y: 321.7,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.1,
    y: 279,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.9,
    y: 293.2,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.8,
    y: 279,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.8,
    y: 335.9,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.7,
    y: 364.4,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.5,
    y: 350.2,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.4,
    y: 364.4,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.2,
    y: 364.4,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.1,
    y: 350.2,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.9,
    y: 335.9,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.8,
    y: 350.2,
    style: {
      fill: "#324A5E"
    },
    width: 19.9,
    height: 14.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.2ab18797287af0063cb704aa72ebe7f5.svg";
export { ForwardRef as ReactComponent };